/**
 * Safe Area utilities for Toss environment
 */

export function isTossEnvironment(): boolean {
  return typeof window !== 'undefined' &&
    (window.location.hostname.includes('toss') ||
     navigator.userAgent.includes('TossApp') ||
     navigator.userAgent.toLowerCase().includes('appintoss'));
}

export function getSafeAreaTop(): number {
  if (typeof window === 'undefined') return 0;

  const computed = getComputedStyle(document.documentElement)
    .getPropertyValue('--safe-area-top').trim();
  const parsed = parseInt(computed);
  if (parsed > 0) return parsed;

  if (isTossEnvironment()) return 44;
  return 0;
}

export function getSafeAreaBottom(): number {
  if (typeof window === 'undefined') return 0;

  const computed = getComputedStyle(document.documentElement)
    .getPropertyValue('--safe-area-bottom').trim();
  const parsed = parseInt(computed);
  if (parsed > 0) return parsed;

  return 0;
}

/**
 * Initialize safe area CSS variables on document root
 */
export function initSafeArea(): void {
  if (typeof document === 'undefined') return;

  const root = document.documentElement;
  root.style.setProperty('--safe-area-top', `env(safe-area-inset-top, ${isTossEnvironment() ? '44px' : '0px'})`);
  root.style.setProperty('--safe-area-bottom', `env(safe-area-inset-bottom, 0px)`);
}
